import { render } from "./changePwd.vue?vue&type=template&id=5f0cca62&scoped=true"
import script from "./changePwd.vue?vue&type=script&lang=js"
export * from "./changePwd.vue?vue&type=script&lang=js"

import "./changePwd.vue?vue&type=style&index=0&id=5f0cca62&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5f0cca62"

export default script